/**
 * El cliente sobre el que se está trabajando, recordado entre navegaciones.
 *
 * Vive en su propio módulo porque lo escribe el armazón (`App.tsx`, al cambiar de cliente en la
 * barra lateral) y lo lee el tablero, que necesita saber a qué cliente mandan sus botones de
 * acción sin poder importar nada de `App.tsx` —lo importaría en círculo—. Dura la sesión,
 * igual que el token: cerrar la pestaña olvida el cliente, que es lo correcto en un equipo
 * compartido de despacho.
 */
const CLAVE_CLIENTE = 'contaquick.clienteActivo'

export function leerClienteRecordado(): string {
  try {
    return sessionStorage.getItem(CLAVE_CLIENTE) ?? ''
  } catch {
    // Navegación privada o almacenamiento bloqueado: se vive sin memoria, no se rompe.
    return ''
  }
}

export function recordarCliente(id: string) {
  try {
    sessionStorage.setItem(CLAVE_CLIENTE, id)
  } catch {
    /* sin memoria entre navegaciones; el resto sigue funcionando */
  }
}
